import { isDev, isProdAPI } from '@/constants/env'

export enum DevEnv {
	BETA = 'BETA',
	PROD = 'PROD',
}

export function toEnvHost(host: string, env: string) {
	return host.replace(/[\w|d|-]\./, (raw) => `${raw.slice(0, -1)}-${env}.`)
}

export default function buildHost(host: string) {
	const { hostname } = window.location

	// dev mode or beta mode
	if (hostname.includes('-beta.')) {
		return toEnvHost(host, 'beta')
	}

	if (isDev && !isProdAPI) {
		const env = import.meta.env.VITE_API_ENV.toLowerCase()
		return toEnvHost(host, env)
	}

	return host
}
